var exports = {
  "n": "x43aef4ae--b7a009--row",
};

module.exports = exports;
